var footerLegacy = 'fx_2d2fb1e5_1uszy570';

export { footerLegacy };
//# sourceMappingURL=footerLegacy.vanilla.mjs.map
